import PropTypes from 'prop-types';
import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { FormInput }     from '../../01-Atoms/FormInput/FormInput'
import { Section }       from '../../02-Molecules/Section/Section'
import { AddressLookUp } from '../../02-Molecules/AddressLookUp/AddressLookUp'

import './SectionPersonalDetails.scss'
import {FormSelect} from "../../01-Atoms/FormSelect/FormSelect";

/**
 * SectionPersonalDetails component
 */
 export const SectionPersonalDetails = forwardRef(({ collapsed, heading, headingLarge, loqateKey, sectionId, recap, values, validationHash, staticText, tracking, trackEvent, ...props }, ref) => {

  const { personal_details } = staticText;
  const { text_before, text_after } = personal_details

  const recapBuild = () => {
    const recap = {}

    if (values.title) {
      recap.title = values.title
    }

    if (values.first_name) {
      recap.first_name = values.first_name
    }

    if (values.last_name) {
      recap.last_name = values.last_name
    }

    if (values.email_address) {
      recap.email_address = values.email_address
    }

    if (values.telephone_number) {
      recap.telephone_number = values.telephone_number
    }

    if (values.contact_address_line_1) {
      recap.contact_address_line_1 = values.contact_address_line_1
    }

    if (values.contact_address_line_2) {
      recap.contact_address_line_2 = values.contact_address_line_2
    }

    if (values.contact_address_line_2) {
      recap.contact_address_line_2 = values.contact_address_line_2
    }

    if (values.contact_address_town_city) {
      recap.contact_address_town_city = values.contact_address_town_city
    }

    if (values.contact_address_town_city) {
      recap.contact_address_post_code = values.contact_address_post_code
    }

    return recap
  }

  const [recapData, recapDataSet] = useState(recapBuild())

  const isValid = () => {
    const keys = [
      'first_name',
      'last_name',
      'email_address',
      'contact_address_line_1',
      'contact_address_town_city',
      'contact_address_post_code'
    ]

    return keys.reduce((isValid, key) => values[key] === '' ? false : isValid, true)
  }

  useImperativeHandle(ref, () => ({ isValid: () => isValid() }))

  /**
   * Handle any form changes.
   *
   * @param {string} name
   *   The name of the value that changed
   * @param {string} value
   *   The new value
   */
  const handlerInputChange = (name, value) => {
    props.onInputChange(name, value)
  }

  return (
    <Section tracking={tracking} trackEvent={trackEvent} collapsed={collapsed} heading={heading} headingLarge={headingLarge} sectionId={sectionId}>

      {text_before && <div dangerouslySetInnerHTML={{ __html: text_before }} />}


      {Object.keys(recapData).length ?
        <div className={'o-section-personal-details__recap'}>
          {recapData.title ? <div>Title: {recapData.title}</div> : null}
          {recapData.first_name ? <div>First name: {recapData.first_name}</div> : null}
          {recapData.last_name ? <div>Last name: {recapData.last_name}</div> : null}
          {recapData.email_address ? <div>Email: {recapData.email_address}</div> : null}
          {recapData.telephone_number ? <div>Telephone: {recapData.telephone_number}</div> : null}

          {(recapData.contact_address_line_1
          || recapData.contact_address_line_2 || recapData.contact_address_town_city || recapData.contact_address_post_code) &&
            <address>
              Address
              {recapData.contact_address_line_1 ? <div>{recapData.contact_address_line_1}</div> : null}
              {recapData.contact_address_line_2 ? <div>{recapData.contact_address_line_2}</div> : null}
              {recapData.contact_address_town_city ? <div>{recapData.contact_address_town_city}</div> : null}
              {recapData.contact_address_post_code ? <div>{recapData.contact_address_post_code}</div> : null}
            </address>
          }

          <button className={'b-button-text-blue'} onClick={() => recapDataSet({})}>Edit</button>
        </div> : null
      }

      {!recapData.title &&
      <FormSelect
        label={'Title'}
        value={values.title}
        required={true}
        name={'title'}
        errorMessage={'Please select a title'}
        onInputChange={handlerInputChange}
        validationHash={validationHash}
        options={(['Miss', 'Ms', 'Mr', 'Mrs', 'Dr', 'Reverend', 'Professor', 'Other']).map(
            value => { return {value: value, label: value}}
          )}
      />
      }

      {!recapData.first_name &&
        <FormInput
          label={'First name'}
          value={values.first_name}
          required={true}
          name={'first_name'}
          type={'text'}
          onInputChange={handlerInputChange}
          validationHash={validationHash}
          validationMessages={
            [
              { type: 'valueMissing', message: 'Please provide a first name' },
              { type: 'maxlength',  maxlength: 40 },

            ]
          } />
      }

      {!recapData.last_name &&
        <FormInput
          label={'Last name'}
          value={values.last_name}
          required={true}
          name={'last_name'}
          type={'text'}
          onInputChange={handlerInputChange}
          validationHash={validationHash}
          validationMessages={
            [
              { type: 'valueMissing', message: 'Please provide a last name' },
              { type: 'maxlength',  maxlength: 40 }
            ]
          } />
      }

      {!recapData.email_address &&
        <FormInput
          label={'Email address'}
          value={values.email_address}
          required={true}
          name={'email_address'}
          type={'email'}
          onInputChange={handlerInputChange}
          validationHash={validationHash}
          loqateKey={loqateKey}
          validationMessages={
            [
              { type: 'valueMissing', message: 'Please provide an email address' },
              { type: 'typeMismatch', message: 'Please enter a valid email address' },
              { type: 'patternMismatch', message: 'Please enter a valid email address' },
              { type: 'maxlength',  maxlength: 500 },
            ]
          } />
      }

      {!recapData.telephone_number &&
        <FormInput
          label={'Telephone'}
          value={values.telephone_number}
          required={false}
          name={'telephone_number'}
          type={'tel'}
          onInputChange={handlerInputChange}
          validationHash={validationHash}
          validationMessages={
            [
              { type: 'patternMismatch', message: 'Please enter a valid UK phone number', pattern: "^([\\+0-9]*)$" },
              { type: 'minlength',  minlength: 6 },
              { type: 'maxlength',  maxlength: 15 },
            ]
          } />
      }

      {
        !recapData.contact_address_line_1 &&
        !recapData.contact_address_line_2 &&
        !recapData.contact_address_town_city &&
        !recapData.contact_address_post_code &&
        <AddressLookUp
          legend={'Your address'}
          loqateKey={loqateKey}
          names={{
            addressLine1 : 'contact_address_line_1',
            addressLine2 : 'contact_address_line_2',
            townCity     : 'contact_address_town_city',
            postCode     : 'contact_address_post_code',
          }}
          showLookup={true}
          onInputChange={props.onInputChange}
          tracking={tracking}
          trackEvent={trackEvent}
          validationHash={validationHash}
          values={{
            addressLine1: values.contact_address_line_1,
            addressLine2: values.contact_address_line_2,
            townCity    : values.contact_address_town_city,
            postCode    : values.contact_address_post_code,
          }} />
      }

      {text_after && <div dangerouslySetInnerHTML={{ __html: text_after }} />}
    </Section>
  )
})

SectionPersonalDetails.propTypes = {
  loqateKey: PropTypes.string,
  collapsed: PropTypes.bool,
  heading: PropTypes.string,
  headingLarge: PropTypes.bool,
  sectionId: PropTypes.string,
  validationHash: PropTypes.string,
  recap: PropTypes.bool,
  onInputChange: PropTypes.func,
  staticText: PropTypes.shape({
    personal_details: PropTypes.shape({
      text_before: PropTypes.string,
      text_after: PropTypes.string,
    })
  }),
  tracking: PropTypes.shape({
    id  : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    type: PropTypes.oneOf(['entry', 'exit', 'entry_exit'])
  }),
  trackEvent: PropTypes.func,
  values: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email_address: PropTypes.string,
    telephone_number: PropTypes.string,
    contact_address_line_1: PropTypes.string,
    contact_address_line_2: PropTypes.string,
    contact_address_town_city: PropTypes.string,
    contact_address_post_code: PropTypes.string,
  })
}

SectionPersonalDetails.defaultProps = {
  collapsed: false,
  recap: false
}
